import {withWidth} from '@material-ui/core';
import {WithWidth} from '@material-ui/core/withWidth';
import {PageNavigationActions} from 'Core/models/Page';
import * as EnrollmentFileActions from 'Enrollment/ducks/enrollmentFileProcessing';
import {EnrollmentFile} from 'Enrollment/models/EnrollmentFile';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import {selectCurrentAgentNumbers} from 'Users/selectors/userProfileSelectors';
import EMWEnrollmentFilesTable from './EMWEnrollmentFilesTable';
import './EnrollmentFileProcessing.sass';
import ESREnrollmentFilesTable from './ESREnrollmentFilesTable';

type PropsFromRedux = typeof EnrollmentFileActions & ReturnType<typeof mapStateToProps>;

type EnrollmentFileProps = PageNavigationActions<EnrollmentFile> &
  WithWidth &
  RouteComponentProps &
  PropsFromRedux &
  RouteComponentProps;

export const EnrollmentFiles = (props: EnrollmentFileProps) => {
  const {
    getEnrollmentFiles,
    clearEnrollmentFiles,
    changeEnrollmentFileFilters,
    enrollmentFiles,
    filters,
    history,
    showEMW,
  } = props;

  useEffect(() => {
    getEnrollmentFiles(undefined, filters);
  }, [filters, getEnrollmentFiles]);

  useEffect(
    () =>
      history.listen(location => {
        if (!location.pathname.includes('/enrollmentFileProcessing') && !location.pathname.includes('/enrollmentGenelcosheetStatusDetails')) {
          clearEnrollmentFiles();
          changeEnrollmentFileFilters(EnrollmentFileActions.ESREmptyEnrollmentFileFilter);
        }
      }),
    [changeEnrollmentFileFilters, clearEnrollmentFiles, filters, history]
  );

  useEffect(() => {
    getEnrollmentFiles(undefined, {
      ...filters,
      fileType: showEMW ? EnrollmentFileActions.EnrollmentFileType.EMW : EnrollmentFileActions.EnrollmentFileType.ESR,
    });
  }, [filters, getEnrollmentFiles, showEMW]);

  return (
    <>
      {showEMW ? (
        <EMWEnrollmentFilesTable enrollmentFilesData={enrollmentFiles} />
      ) : (
        <ESREnrollmentFilesTable enrollmentFilesData={enrollmentFiles} />
      )}
    </>
  );
};

const mapStateToProps = (state: ReducerState) => ({
  agentNumbers: selectCurrentAgentNumbers(state),
  enrollmentFiles: state.enrollmentFileProcessing.enrollmentFiles,
  showEMW: state.enrollmentFileProcessing.showEMW,
  filters: state.enrollmentFileProcessing.enrollmentFilesFilter,
});

export default withRouter(
  connect(mapStateToProps, {
    ...EnrollmentFileActions,
  })(withWidth()(EnrollmentFiles))
);
